import { EPData } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { EventShare } from '@rsos/reduxDataStore/src/features/eventShare/types';
import { Tag, TagWrapper } from './EventShareAccordionContent.styles';

const configNameMap: Record<string, string> = {
  incident_location: 'Location',
  map: 'Map',
  additional_data: 'Additional Data',
  live_chat: 'Live Chat',
  live_video: 'Live Video',
  live_transcript: 'Call Transcript',
  incident_summary: 'Call Summary',
};
const DataShared = ({ share }: { share: EventShare }) => {
  return (
    <Box>
      <Box horizontal flow={4} align="center" color="primaryText">
        <EPData height={14} width={14} />
        <Text fontWeight="bold" size="normal">
          Data Shared
        </Text>
      </Box>
      <TagWrapper>
        {share.display_config.map((config, index) => (
          <Tag key={index}>
            <Text size="small">
              {configNameMap[config.name as keyof typeof configNameMap]}
            </Text>
          </Tag>
        ))}
      </TagWrapper>
    </Box>
  );
};

export default DataShared;
